module.exports = __webpack_public_path__ + "assets/img/text-wb-1a1ddf0d.png";